import { useTranslation } from "react-i18next";
import type { languages } from "@/i18n";

export function useLangChange() {
	const { i18n } = useTranslation();
	const currentLocale = i18n.language;

	const setLang = (newLocale: (typeof languages)[number]) => {
		i18n.changeLanguage(newLocale);
	};

	return {
		currentLocale,
		setLang,
	};
}
